import React from 'react';
import PropTypes from 'prop-types';
import SubmitSignInForm from 'platform/static-data/SubmitSignInForm';
import { useFeatureToggle } from 'platform/utilities/feature-toggles';
import {
  getQueryParams,
  isClearEligible,
} from 'platform/user/authentication/utilities';
import { OCC_CLIENT_IDS } from '../constants';

const LoginInfo = ({
  clearPreviewEnabled,
  externalApplication,
  showPasskeyButton,
}) => {
  const { application, clientId } = getQueryParams();
  const { TOGGLE_NAMES, useToggleValue } = useFeatureToggle();
  const clearSigninEnabled = useToggleValue(TOGGLE_NAMES.clearSigninEnabled);
  const pivEnabled = useToggleValue(TOGGLE_NAMES.pivSigninEnabled);
  const identityPasskeyEnabled = useToggleValue(
    TOGGLE_NAMES.identityPasskeyEnabled,
  );
  const occPasskeyEnabled = useToggleValue(TOGGLE_NAMES.occPasskeyEnabled);

  const arpEnabled = pivEnabled && application === 'arp';
  const passkeyEnabled = identityPasskeyEnabled || showPasskeyButton;
  const passkeyLinkVisible =
    passkeyEnabled &&
    (isClearEligible({ clientId, externalApplication }) ||
      (occPasskeyEnabled && OCC_CLIENT_IDS.includes(clientId)));
  const clearVisible =
    (clearSigninEnabled || clearPreviewEnabled) && application !== 'arp';

  const supportLinks = [
    ...(clearVisible
      ? [
          {
            text: 'You can now sign in with CLEAR',
            url: '/sign-in/sign-in-to-vagov-with-clear',
            isNew: true,
          },
        ]
      : []),
    ...(passkeyLinkVisible
      ? [
          {
            text: 'Learn more about passkeys',
            url: '/resources/create-and-use-passkeys-on-vagov/',
            isNew: true,
          },
        ]
      : []),
    ...(!passkeyEnabled && clearVisible && !arpEnabled
      ? [
          {
            text: 'Learn about creating an account',
            url: '/resources/creating-an-account-for-vagov',
          },
        ]
      : []),
    ...(!arpEnabled
      ? [
          {
            text: passkeyEnabled ? 'Signing in to VA.gov' : 'Sign-in errors',
            url: '/resources/signing-in-to-vagov/',
          },
        ]
      : []),
    {
      text: 'Verifying your identity',
      url: '/resources/verifying-your-identity-on-vagov/',
    },
    {
      text: 'Deleting your account',
      url: passkeyEnabled
        ? '/resources/can-i-delete-my-idme-logingov-or-clear-account/'
        : '/resources/can-i-delete-my-logingov-or-idme-account',
    },
    passkeyEnabled
      ? {
          text: 'Common issues with sign-in accounts',
          url: '/resources/support-for-common-sign-in-account-issues/',
        }
      : {
          text: clearVisible
            ? 'Common issues with ID.me, Login.gov, or CLEAR'
            : 'Common issues with ID.me or Login.gov',
          url: '/resources/support-for-common-logingov-and-idme-issues/',
          ...(clearVisible && {
            ariaLabel: 'Common issues with ID.me, Login.gov, or Clear',
          }),
        },
    ...(arpEnabled
      ? [
          {
            text: 'Signing-in with a VA PIV card',
            url: '/resources/signing-in-to-vagov/',
          },
        ]
      : []),
  ];
  return (
    <div className="row">
      <div className="columns print-full-width sign-in-wrapper">
        <div className="help-info">
          <h2 className="vads-u-margin-top--0">Help and support</h2>

          <div>
            <div>
              <ul className="vads-u-padding-bottom--3">
                {supportLinks.map((link, idx) => (
                  <li className="vads-u-margin--0" key={idx}>
                    {link.isNew && (
                      <span className="usa-label vads-u-margin-right--0p5">
                        New
                      </span>
                    )}
                    <a href={link.url} aria-label={link.ariaLabel}>
                      {link.text}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          </div>
          <p>
            <SubmitSignInForm startSentence />
          </p>
        </div>
      </div>
    </div>
  );
};

LoginInfo.propTypes = {
  clearPreviewEnabled: PropTypes.bool,
  externalApplication: PropTypes.string,
  showPasskeyButton: PropTypes.bool,
};

export default LoginInfo;
